import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {fb} from "./firebase";

Vue.config.productionTip = false;
// bootstrap
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// VueAgile slider
import VueAgile from 'vue-agile'
Vue.use(VueAgile)

// main scss
import "./sass/main.scss";

// filters
Vue.filter('currency', (value) => {
  return `$${Number(value).toFixed(2).toLocaleString()}`;
});

// vue firestore
import VueFirestore from 'vue-firestore';

import i18n from './i18n'
Vue.use(VueFirestore, {
  key: 'id',         // the name of the property. Default is '.key'.
  enumerable: true  //  whether it is enumerable or not. Default is true.
});


fb.auth().onAuthStateChanged(function() {
  new Vue({
    router,
    store,
    render: h => h(App),
    i18n,

    created() {
      store.dispatch("authModule/autoSignIn");
    }
  }).$mount("#app");
});

